const IPFS_GATEWAY_URL = process.env.REACT_APP_IPFS_GATEWAY_URL
if (typeof IPFS_GATEWAY_URL === 'undefined') {
  throw new Error(
    'REACT_APP_IPFS_GATEWAY_URL must be a defined environment variable'
  )
}

const PASS_THROUGH_SCHEME = /^(https?|data):/

/**
 * Maps a URI to one the browser can load: `ipfs://` and bare CID paths go
 * through the gateway; http(s) and data URIs stay as they are.
 */
export const getIpfsUrl = (uri: string): string => {
  if (uri.startsWith('ipfs://')) {
    return uri.replace('ipfs://', IPFS_GATEWAY_URL)
  }
  if (PASS_THROUGH_SCHEME.test(uri)) {
    return uri
  }
  return `${IPFS_GATEWAY_URL}${uri}`
}

export const toHttpUrl = (uri: string | undefined): string | null =>
  uri ? getIpfsUrl(uri) : null

export const isIpfsGatewayUrl = (url: string): boolean =>
  url.startsWith(IPFS_GATEWAY_URL)
